module.exports = __webpack_public_path__ + "static/media/IOTSU_L5R_L04.3cf7371b.jpg";